/**
 * DataTable — render de tabela (desktop) do ListView.
 *
 * Não é normalmente usado direto; o ListView escolhe entre DataTable
 * (desktop) e CardList (mobile). Exposto para casos onde a página quer
 * forçar tabela.
 *
 * table-layout: fixed (zero scroll lateral). Colunas dimensionadas via
 * col.width; conteúdo excedente usa ellipsis.
 */
import React from "react";
import {
  TableWrap,
  Table,
  Thead,
  Th,
  Tbody,
  Tr,
  Td,
  SkeletonRow,
} from "./styles";

function resolveCell(col, row, index) {
  if (typeof col.render === "function") return col.render(row, index);
  return row?.[col.key];
}

export default function DataTable({
  data,
  columns,
  rowKey,
  onRowClick,
  loading,
  loadingRows = 6,
}) {
  return (
    <TableWrap>
      <Table>
        <colgroup>
          {columns.map((col) => (
            <col
              key={col.key}
              style={col.width ? { width: col.width } : undefined}
            />
          ))}
        </colgroup>
        <Thead>
          <tr>
            {columns.map((col) => (
              <Th key={col.key} $align={col.align}>
                {col.label}
              </Th>
            ))}
          </tr>
        </Thead>
        <Tbody>
          {loading
            ? Array.from({ length: loadingRows }).map((_, r) => (
                <Tr key={`sk-${r}`}>
                  {columns.map((col) => (
                    <Td key={col.key}>
                      <SkeletonRow style={{ width: `${50 + ((r + col.key.length) % 5) * 8}%` }} />
                    </Td>
                  ))}
                </Tr>
              ))
            : data.map((row, index) => (
                <Tr
                  key={rowKey(row, index)}
                  $clickable={Boolean(onRowClick)}
                  onClick={onRowClick ? () => onRowClick(row) : undefined}
                >
                  {columns.map((col) => (
                    <Td key={col.key} $align={col.align} title={
                      typeof resolveCell(col, row, index) === "string"
                        ? resolveCell(col, row, index)
                        : undefined
                    }>
                      {resolveCell(col, row, index)}
                    </Td>
                  ))}
                </Tr>
              ))}
        </Tbody>
      </Table>
    </TableWrap>
  );
}
